import React from 'react';
import { useQuery } from '@apollo/client';
import { loader } from 'graphql.macro';
const GET_PRODUCTS_BY_COLOR_QTY = loader('./GetProductsByColorQty.shopify.graphql');

export const ShopByColorUI = (config: {
  colorTag: string;
  gender: string;
  shopByColorURL: string;
  showColorInLink?: boolean;
  prependDivider?: boolean;
}) => {
  const { showColorInLink = true } = config;
  const { data } = useQuery(GET_PRODUCTS_BY_COLOR_QTY, {
    variables: config && {
      first: 2,
      query: `tag:'${config.colorTag}' tag:'X:IsPublishedToOnlineStore' available_for_sale:true product_type:${
        config.gender
      }* OR product_type:Accessories* AND tag:'YCRF_reviews:${config.gender.toLowerCase()}'`,
    },
    skip: !config,
  });

  return data && data.products.edges.length >= 2 ? (
    <>
      {config.prependDivider && <span style={{ margin: '0 5px', textDecoration: 'none' }}>|</span>}
      <a href={config.shopByColorURL} className="shop-by-color action-link body-text-link-small">
        {showColorInLink ? `Shop All ${config.colorTag.replace(/Color:|:Color/g, '')}` : 'Shop All'}
      </a>
    </>
  ) : null;
};

export default ShopByColorUI;
